import { stateGo } from 'redux-ui-router';
import { USAGE_CAPS_URL } from '../../../servicesAndUsage/usageCaps/usage.caps.constants';
import { SERVICES_AND_SHARED_ENTITLEMENTS, SERVICE_DETAILS_STATE_NAME } from '../../services.and.usage.config';
import { SERVICE_USAGE_DETAILS_STATE_NAME } from '../../../servicesAndUsage/usageDetails/usage.details.config';
import { SERVICE_ADD_ON_PRODUCTS_ORDERING_PAGE_ROUTE, USAGE_DETAILS_NON_TELCO_SERVICES_REDIRECT } from '../../../../../reactRoutes';
export var SERVICES_MORE_OPTIONS_CONSTANTS = {
  VIEW_SERVICE_ATTRIBUTES: 1,
  VIEW_SERVICE_DETAILS: 2,
  VIEW_USAGE_CAPS: 3,
  VIEW_MANAGE_FEATURES: 4,
  RESUME_SERVICE: 5,
  SUSPEND_SERVICE: 6,
  UPDATE_SERVICE_LIFECYCLE_STATUS: 7
};
export function navigateToView(ngRedux, targetURL) {
  var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  ngRedux.dispatch(stateGo(targetURL, params));
}
export function handleMoreOptionSelected(scope, log, ngRedux, routeParams, entity) {
  var _this = this;
  var params = {};
  return function (_ref) {
    var item = _ref.item;
    switch (item.id) {
      case SERVICES_MORE_OPTIONS_CONSTANTS.VIEW_SERVICE_ATTRIBUTES:
        _this.openServiceAttributes(entity);
        return;
      case SERVICES_MORE_OPTIONS_CONSTANTS.RESUME_SERVICE:
        _this.onOpenSuspendService()(entity);
        return;
      case SERVICES_MORE_OPTIONS_CONSTANTS.SUSPEND_SERVICE:
        _this.onOpenSuspendService()(entity);
        return;
      case SERVICES_MORE_OPTIONS_CONSTANTS.VIEW_SERVICE_DETAILS:
        params = {
          serviceIdentifier: entity.ServiceIdentifier.Value
        };
        _this.navigateToView(SERVICE_DETAILS_STATE_NAME, params);
        return;
      case SERVICES_MORE_OPTIONS_CONSTANTS.VIEW_USAGE_CAPS:
        params = {
          serviceId: entity.ServiceIdentifier.Value
        };
        _this.navigateToView(USAGE_CAPS_URL, params);
        return;
      case SERVICES_MORE_OPTIONS_CONSTANTS.VIEW_MANAGE_FEATURES:
        if (!item.isLocked) {
          _this.navigateToView(SERVICE_ADD_ON_PRODUCTS_ORDERING_PAGE_ROUTE, {
            customerId: routeParams.customerId,
            serviceIdentifierValue: entity.ServiceIdentifier.Value,
            serviceId: entity.ServiceIdentifier.ServiceId,
            serviceAttributeId: entity.ServiceIdentifierAttributeId
          });
        }
        return;
      case SERVICES_MORE_OPTIONS_CONSTANTS.UPDATE_SERVICE_LIFECYCLE_STATUS:
        _this.openUpdateServiceLifeCycleStatus(entity);
        return;
      default:
        return;
    }
  };
}
export function navigateToUsageDetails(routeParams, entity) {
  var params = {
    serviceIdentifierName: entity.ServiceName,
    serviceAttributeId: entity.ServiceIdentifierAttributeId,
    serviceIdentifierValue: entity.ServiceIdentifier.Value,
    serviceIdentifierFriendlyName: entity.ServiceName,
    fromStateObject: {
      name: SERVICES_AND_SHARED_ENTITLEMENTS,
      params: routeParams
    }
  };
  this.navigateToView(SERVICE_USAGE_DETAILS_STATE_NAME, params);
}
export function navigateToNonTelcoUsageDetails(routeParams, entity) {
  var params = {
    customerId: routeParams.customerId,
    serviceIdentifierValue: entity.ServiceIdentifier.Value
  };
  this.navigateToView(USAGE_DETAILS_NON_TELCO_SERVICES_REDIRECT, params);
}